import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addDiscountCode, updateDiscountCode, fetchDiscountCodes } from "../../actions/discountCodes";
import { getAllDiscountCodes } from "../../reducers";
import api from "../../api/api"; // Ensure you import the `api` object
import './EditDiscountCodePage.css';

const EditDiscountCodePage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const allCodes = useSelector(getAllDiscountCodes);

    const isNew = id === "new";

    const [formData, setFormData] = useState({
        code: "",
        discount: 0,
        valid: true,
        startDate: "",
        endDate: "",
        validForAllProducts: true,
        possibleUsageTimes: 1,
        usageTimes: 0,
        productsIds: [],
    });

    const [products, setProducts] = useState([]);

    useEffect(() => {
        api.getProductsPromise(200)
            .then(res => {
                setProducts(res.content || []);
            })
            .catch(err => console.error("Error loading products:", err));
    }, []);

    useEffect(() => {
        if (!isNew) {
            dispatch(fetchDiscountCodes());
        }
    }, [dispatch, isNew]);

    useEffect(() => {
        if (!isNew && allCodes.length > 0) {
            const selected = allCodes.find((c) => c.id === parseInt(id));
            if (selected) {
                setFormData({
                    ...selected,
                    productsIds: selected.productsIds || []
                });
            }
        }
    }, [allCodes, id, isNew]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleMultiSelectChange = (e) => {
        const selectedOptions = Array.from(e.target.selectedOptions);
        const selectedIds = selectedOptions.map(option => parseInt(option.value));
        setFormData(prev => ({
            ...prev,
            productsIds: selectedIds
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isNew) {
            dispatch(addDiscountCode(formData));
        } else {
            dispatch(updateDiscountCode(id, formData));
        }
        navigate("/admin/discounts");
    };

    return (
        <div className="discount-container font-tiskani-order-page">
            <div className="order">
                <h2 className="padding-order-page-text font-tiskani">
                    {isNew ? "Novi kod za popust" : "Uredi kod"}
                </h2>

                <form onSubmit={handleSubmit} className="discount-form">
                    <label>Kod:
                        <input
                            type="text"
                            name="code"
                            value={formData.code}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    <label>Popust (upiši broj između 0 i 1):
                        <input
                            type="number"
                            name="discount"
                            value={formData.discount}
                            min={0}
                            max={1}
                            step={0.01}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    <label>Datum početka:
                        <input
                            type="date"
                            name="startDate"
                            value={formData.startDate}
                            onChange={handleChange}
                        />
                    </label>

                    <label>Datum završetka:
                        <input
                            type="date"
                            name="endDate"
                            value={formData.endDate}
                            onChange={handleChange}
                        />
                    </label>

                    <label>Maks. korištenja:
                        <input
                            type="number"
                            name="possibleUsageTimes"
                            value={formData.possibleUsageTimes}
                            onChange={handleChange}
                            min={1}
                        />
                    </label>

                    {!isNew && (
                        <div className="usage-info">
                            Korišteno: {formData.usageTimes}/{formData.possibleUsageTimes}
                        </div>
                    )}

                    <label>
                        <input
                            type="checkbox"
                            name="valid"
                            checked={formData.valid}
                            onChange={handleChange}
                        />
                        Aktiviran
                    </label>

                    <label>
                        <input
                            type="checkbox"
                            name="validForAllProducts"
                            checked={formData.validForAllProducts}
                            onChange={handleChange}
                        />
                        Vrijedi za sve proizvode
                    </label>

                    {!formData.validForAllProducts && (
                        <label>Odaberi proizvode:
                            <select
                                multiple
                                value={formData.productsIds.map(id => id.toString())}
                                onChange={handleMultiSelectChange}
                            >
                                {products.map((product) => (
                                    <option key={product.id} value={product.id}>
                                        {product.productName}
                                    </option>
                                ))}
                            </select>
                        </label>
                    )}

                    <div className="discount-submit">
                        <button type="submit" className="btn btn-primary">
                            Spremi kod
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditDiscountCodePage;
